module.exports = __webpack_public_path__ + "static/media/money-transfers-bg.3ad99512.png";